import { z } from 'zod';
import { SITE_STATUTS, SITE_TYPES } from '../constants/statuses.js';
import { paginationQuerySchema } from './common.js';
/**
 * Sites opérationnels (direction, dépôts, agences…). Le modèle Prisma existe
 * depuis le Sprint 0 mais n'avait jamais eu d'écran ni de route de création :
 * seul le seed posait la Direction Générale. Conséquence constatée en
 * production — un mouvement logistique exigeant un site source ET un site
 * destination, il était impossible d'expédier quoi que ce soit faute de
 * seconde ligne en base, donc impossible d'amener une carte jusqu'au statut
 * `active`. Ces schémas ne valident que la forme des requêtes.
 */
export const createSiteSchema = z.object({
    codeSite: z
        .string()
        .trim()
        .min(2)
        .max(30)
        // Code court repris dans les écrans et les exports : on le fige en
        // majuscules/chiffres/tiret pour qu'il reste lisible et comparable.
        .regex(/^[A-Z0-9-]+$/, 'Lettres majuscules, chiffres et tirets uniquement'),
    nomSite: z.string().trim().min(2).max(160),
    typeSite: z.enum(SITE_TYPES),
    province: z.string().trim().min(2).max(80),
    ville: z.string().trim().min(2).max(80),
    adresse: z.string().trim().max(500).optional(),
    telephone: z.string().trim().max(30).optional(),
});
/**
 * `codeSite` volontairement absent : il sert de clé unique lisible et est
 * repris dans les mouvements déjà enregistrés — le renommer après coup
 * rendrait l'historique logistique incompréhensible. Un site fermé se passe
 * en `inactif`, il ne se renomme pas et ne se supprime pas (les mouvements
 * qui le référencent doivent rester lisibles).
 */
export const updateSiteSchema = z
    .object({
    nomSite: z.string().trim().min(2).max(160),
    typeSite: z.enum(SITE_TYPES),
    province: z.string().trim().min(2).max(80),
    ville: z.string().trim().min(2).max(80),
    adresse: z.string().trim().max(500).nullable(),
    telephone: z.string().trim().max(30).nullable(),
    statutSite: z.enum(SITE_STATUTS),
})
    .partial()
    .refine((data) => Object.keys(data).length > 0, {
    message: 'Aucune modification fournie',
});
export const listSitesQuerySchema = paginationQuerySchema.extend({
    statutSite: z.enum(SITE_STATUTS).optional(),
    typeSite: z.enum(SITE_TYPES).optional(),
});
//# sourceMappingURL=sites.js.map